common.View.create('canvas.blocks.custom.portfolioSlider.Block', {
    onDOMLoad() {
        this.initSwiper();
    },

    initSwiper() {
        let swiperEl = this.element.find('.portfolioSwiper');

        if (swiperEl.data('swiper-enabled') === false) {
            return;
        }

        new Swiper('.portfolioSwiper', {
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
                480: {
                    slidesPerView: 2,
                    spaceBetween: 75,
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            mousewheel: {
                releaseOnEdges: true,
                sensitivity: 1,
                invert: false,
            },
        });
    },
});
